import axios from 'axios'
import i18n from '@/i18n'
const state = {
    educationalYears: [],
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
}
const getters = {
    getEducationalYears(state) {
        return state.educationalYears
    },
    getTableOptions(state) {
        return state.tableOptions
    },

}
const mutations = {
    setEducationalYears(state, educationalYears) {
        state.educationalYears = educationalYears
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    }
}
const actions = {
    async fetchEducationalYears({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {
                size: 10,
                name: queryParams.nameSearch,
            };
            if (queryParams.paginationValue) {
                params.page = queryParams.paginationValue;
            }
            if (!queryParams.nameSearch) {
                delete params.name;
            }
            const response = await axios.get("/educational-year", {
                params,
            });
            response.data.educational_years = response.data.educational_years.map((el)=>{
                return {
                    ...el,
                    active: el.active ? i18n.t('Active') : i18n.t('Un Active') ,
                }
            })
            commit('setTableData', {
                tableHeaders: ["id", "name", "begin", "end","Active", "settings"],
                tableData: response.data.educational_years,
                accessTableData: [["id"], ["name"], ["start"], ["end"],["active"]],
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchAllEduYears({ commit }) {
        try {
            const educationalYears = await axios.get("/educational-year", {
                params: {
                    size: 100000,
                },
            });
            commit('setEducationalYears', educationalYears.data.educational_years)
        }
        catch (err) {
            console.error('err', err);
        }
        finally { }
    },
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}